import React from 'react';

import useProjectRelocationModal from 'components/projectsDashboard/hooks/useProjectRelocationModal';

export const ProjectRelocationModalContext = React.createContext({});

export const useProjectRelocationModalContext = () =>
  React.useContext(ProjectRelocationModalContext);

export default function ProjectRelocationModalContextProvider({ children }) {
  const {
    createFolderMutation,
    creationBlockingExistingFolder,
    currentFolder,
    handleCurrentFolderInputChange,
    handleDestinationFolderSelect,
    handleReset,
    selectedDestinationFolderId,
  } = useProjectRelocationModal();

  return (
    <ProjectRelocationModalContext.Provider
      value={{
        createFolderMutation,
        creationBlockingExistingFolder,
        currentFolder,
        handleCurrentFolderInputChange,
        handleDestinationFolderSelect,
        handleReset,
        selectedDestinationFolderId,
      }}
    >
      {children}
    </ProjectRelocationModalContext.Provider>
  );
}
